// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__7BkWY","title":"InfoRow_title__2l1_p"};